module.exports = __webpack_public_path__ + "25a32416abee198dd821b0b17a198a8f.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.eot
 ** module id = 140
 ** module chunks = 0
 **/